import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>
       copyright © {new Date().getFullYear()} Preetibarsha Dash. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
